const getDataFromFilterData = (filterData, fieldName, operand) =>
  filterData?.where?.find?.(
    (item) => item.includes(fieldName) && item?.includes(operand)
  )?.[2]

export default getDataFromFilterData
